<template>
    <activation-brief-task-delivery-provider
        v-slot="{
            isPreview,
            isLoading,
            isDelivering,
            deliverTask,
            errors,
            errorMessage,
            goToExitRoute,
            task,
            brandNetworks,
            uploadContentUrl,
            uploadedContentDeliveryUrl,
            deleteUploadedContentUrl,
            handleFileChange,
            handleResetUploads,
            handleUploadFailed,
            uploadHeaders,
            uploadedFiles,
            hasUploadedFiles,
            isFileUploading,
            isTaskContentLoading,
            taskContent,
            quantityString,
            goBack
        }"
        style="height: 100%"
    >
        <activation-brief-task-delivery-view
            :is-loading="isLoading"
            :is-delivering="isDelivering"
            :errors="errors"
            :error-message="errorMessage"
            :task="task"
            :brand-networks="brandNetworks"
            :upload-content-url="uploadContentUrl"
            :uploaded-content-delivery-url="uploadedContentDeliveryUrl"
            :delete-uploaded-content-url="deleteUploadedContentUrl"
            :upload-headers="uploadHeaders"
            :uploaded-files="uploadedFiles"
            :has-uploaded-files="hasUploadedFiles"
            :is-file-uploading="isFileUploading"
            :is-task-content-loading="isTaskContentLoading"
            :task-content="taskContent"
            :quantity-string="quantityString"
            @file-change="handleFileChange"
            @reset-uploads="handleResetUploads"
            @upload-failed="handleUploadFailed"
            @deliver="deliverTask"
            @exit="goToExitRoute"
            @back="goBack"
        />
    </activation-brief-task-delivery-provider>
</template>

<script>
    import ActivationBriefTaskDeliveryProvider from '../providers/activation-brief-steps/ActivationBriefTaskDeliveryProvider.vue';
    import ActivationBriefTaskDeliveryView from '../data-views/activation-briefs/partials/tasks/ActivationBriefTaskDeliveryView.vue';

    export default {
        name: 'ActivationBriefTaskDeliveryRouterView',
        components: {
            ActivationBriefTaskDeliveryProvider,
            ActivationBriefTaskDeliveryView
        }
    };
</script>
